import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const RealTimeInventory = {
	name: NAME,
	apiProvider,
	router,
};
